<template>
  <v-row>
    <v-col :cols="12">
      <material-card class="mt-0" color="green" title="Social Networks">
        <v-row justify="center" style="height: 70px; line-height: 70px;">

          <div v-for="(provider_type, i) in providers" style="min-width: 74px; text-align: center">
            <v-hover v-slot="{ hover }">
              <v-btn
                :color="hover && isActiveSocial(provider_type) ? 'blue' : 'light-blue lighten-1'"
                :disabled="!isActiveSocial(provider_type)"
                icon
                x-large
                width="74"
                height="74"
                @click="unlink(provider_type)"
              >
                <v-icon
                  :size="hover ? 50 : 40"
                  class="ma-3"
                >
                  mdi-{{ provider_type }}
                </v-icon>
              </v-btn>
            </v-hover>
          </div>

        </v-row>
      </material-card>
    </v-col>
  </v-row>
</template>

<style>
  .custom_label > label div {
    vertical-align: super;
    display: inline-block;
    cursor: pointer;
    user-select: none;
    line-height: 24px;
  }
</style>

<script>
  import { API } from '@/utils/api'
  import { mapGetters } from 'vuex'
  import { uniq, map, includes } from 'lodash'

  export default {
    props: [],

    components: {},

    data: () => ({
      defaultProviders: [
        'facebook',
        'google',
        'twitch',
      ]
    }),

    computed: {
      ...mapGetters({ activeAccount: 'account/active', oauth: 'account/oauth' }),
      providers () {
        return uniq([ ...this.defaultProviders, ...this.activeProviders ])
      },
      activeProviders () {
        return map(this.oauth, 'provider_type')
      }
    },

    mounted () {
    },

    methods: {
      isActiveSocial (provider_type) {
        return includes(this.activeProviders, provider_type)
      },

      async unlink (provider_type) {

        if (!await this.$root.$confirm('Confirm', `Unlink ${provider_type}?`)) {
          return
        }

        this.activeAccount.loading = true

        API.call('/$v/account/oauth/unlink.json', {
          login: this.activeAccount.account.login,
          account_id: this.activeAccount.account.account_id,
          provider_type,
        }, this.activeAccount.account).then(resp => {
          this.$notification.show = true
          this.$notification.message = 'Social Network was successfully unlinked: ' + provider_type + ''
          this.$notification.type = 'success'

          return this.$store.dispatch('account/loadOAuth', this.activeAccount)
        }).catch(e => {
          return e
        }).finally(() => {
          this.activeAccount.loading = false
        })
      }
    },

  }
</script>
